'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { id: 'faq-1', q: 'How are cleaners vetted?', a: 'Every cleaner on EzCleanCare completes an identity verification, a DBS (Disclosure and Barring Service) criminal background check, reference checks, and our 40-hour training programme before their first job.' },
  { id: 'faq-2', q: 'What if I\'m not happy with the clean?', a: 'We offer a 100% free re-clean guarantee. If you\'re not satisfied within 24 hours of your service, contact support and we\'ll send a cleaner back at no cost.' },
  { id: 'faq-3', q: 'Can I request the same cleaner every time?', a: 'Yes. Once you\'ve had a great experience, you can request that cleaner for all future bookings. We\'ll do our best to match your schedule.' },
  { id: 'faq-4', q: 'How does pricing work?', a: 'Pricing is based on property size, service type, and frequency. You\'ll see an exact price before confirming your booking — no hidden fees, ever.' },
  { id: 'faq-5', q: 'Do I need to be home during the cleaning?', a: 'No. Many customers provide entry instructions or a key safe code. Your cleaner will document arrival and completion with timestamped photos.' },
  { id: 'faq-6', q: 'What areas do you serve?', a: 'We currently operate in London, Manchester, Birmingham, Leeds, Bristol, and Edinburgh, with more cities launching in 2026. Enter your postcode at booking to confirm availability.' },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="faq" className="py-20 bg-muted/40">
      <div className="max-w-3xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">FAQ</p>
          <h2 className="text-hero-md font-extrabold text-foreground">Common Questions</h2>
        </div>
        <div className="space-y-3">
          {faqs?.map((faq) => (
            <div key={faq?.id} className="bg-card rounded-2xl border border-border overflow-hidden card-shadow">
              <button
                onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-muted/50 transition-colors"
                aria-expanded={openId === faq?.id}
              >
                <span className="text-sm font-semibold text-foreground">{faq?.q}</span>
                <ChevronDown
                  size={18}
                  className={`text-muted-foreground flex-shrink-0 transition-transform duration-200 ${openId === faq?.id ? 'rotate-180' : ''}`}
                />
              </button>
              {openId === faq?.id && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}